import React from "react";

interface DPDPillProps {
  value?: number | null;
}

const DPDPill: React.FC<DPDPillProps> = ({ value }) => {
  let backgroundColor = "#F1F5F9";
  let dotColor = "#9CA3AF";

  if (value !== null && value !== undefined) {
    if (value > 90) {
      backgroundColor = "#FEE2E2";
      dotColor = "#EF4444";
    } else if (value >= 75) {
      backgroundColor = "#FEF9C3";
      dotColor = "#EAB308";
    }
  }

  return (
    <span
      className="inline-flex items-center justify-center gap-1 rounded-[8px] border border-transparent px-2 py-[2px] font-sans text-xs font-medium leading-4 text-[#4B5563]"
      style={{ backgroundColor }}
    >
      <span className="flex h-3 w-3 items-center justify-center">
        <span
          className="h-1.5 w-1.5 rounded-full"
          style={{ backgroundColor: dotColor }}
        />
      </span>

      <span>{value ?? "--"}</span>
    </span>
  );
};

export default DPDPill;